import { TimeRatePayKind, UserDefinedRow } from "../../model";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/**
 * Time rate pay validations
 */
export class TimeRatePayUsecaseLogic extends BaseUsecaseLogic {

  /** Gets validation message for BoardUsecaseLogic  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage | undefined {
    const data: ({ kind?: TimeRatePayKind })= row.data || {};
    if (!data.kind) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noKind",
      };
    }
    return undefined;
  }

}
